var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'inversify';
const FORCE_RELOAD_AT_KEY = 'forceReloadAt';
const FORCE_RELOAD_COOLDOWN = 30000;
let UpdatorService = class UpdatorService {
    constructor() {
        this.shouldReload = false;
        this.forceReloadTriggered = false;
    }
    /**
     * Перезагрузить страницу
     */
    pageReload() {
        window.location.reload();
    }
    /**
     * Время последней принудительной перезагрузки, переживающее саму перезагрузку
     * @returns Метка времени в миллисекундах, 0 если её нет
     */
    getForceReloadAt() {
        try {
            return Number(localStorage.getItem(FORCE_RELOAD_AT_KEY)) || 0;
        }
        catch (e) {
            return 0;
        }
    }
    setForceReloadAt(time) {
        try {
            localStorage.setItem(FORCE_RELOAD_AT_KEY, String(time));
        }
        catch (e) { }
    }
    forceReload() {
        if (this.forceReloadTriggered) {
            return;
        }
        const now = Date.now();
        if (now - this.getForceReloadAt() < FORCE_RELOAD_COOLDOWN) {
            return;
        }
        this.forceReloadTriggered = true;
        this.setForceReloadAt(now);
        this.pageReload();
    }
    /**
     * Обновить версию приложения, если новая отличается от сохраненной ранее
     * @param version - Новая версия
     */
    updateVersion(version) {
        if (version) {
            if (this.version) {
                if (this.version !== version) {
                    this.version = version;
                    this.shouldReload = true;
                }
            }
            else {
                this.version = version;
            }
        }
    }
    /**
     * Проверить необходимо ли перезагрузить приложение, и в случае необходимости выполнить перезагрузку
     * */
    run() {
        if (this.shouldReload) {
            this.shouldReload = false;
            this.pageReload();
        }
    }
};
UpdatorService = __decorate([
    injectable()
], UpdatorService);
export { UpdatorService };
